import { render, staticRenderFns } from "./BaseValidNumber.vue?vue&type=template&id=8515024c&scoped=true&"
import script from "./BaseValidNumber.vue?vue&type=script&lang=js&"
export * from "./BaseValidNumber.vue?vue&type=script&lang=js&"
import style0 from "./BaseValidNumber.vue?vue&type=style&index=0&id=8515024c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8515024c",
  null
  
)

export default component.exports